import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  useTheme,
  alpha,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CancelIcon from '@mui/icons-material/Cancel';

const WorkOrderCancelConfirmationDialog = ({
  open,
  onClose,
  workOrder,
  onConfirmCancel,
  cancelling,
}) => {
  const theme = useTheme();

  if (!workOrder) return null;

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="cancel-work-order-dialog-title"
      aria-describedby="cancel-work-order-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          minWidth: '400px'
        }
      }}
    >
      <DialogTitle 
        id="cancel-work-order-dialog-title"
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          pb: 1
        }}
      >
        <WarningIcon color="error" />
        Cancel Action Log
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="cancel-work-order-dialog-description" sx={{ mb: 2 }}>
          Are you sure you want to cancel this action log? This action cannot be undone.
        </DialogContentText>
        
        {workOrder && (
          <Box sx={{ 
            bgcolor: alpha(theme.palette.error.main, 0.05),
            border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
            borderRadius: 2,
            p: 2,
            mt: 2
          }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'error.main' }}>
              Action Log Details:
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>ID:</strong> {workOrder.work_order_number}
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Title:</strong> {workOrder.title}
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Status:</strong> {workOrder.status}
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Priority:</strong> {workOrder.priority}
            </Typography>
            <Typography variant="body2">
              <strong>Created:</strong> {formatDateTime(workOrder.created_at)}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          disabled={cancelling}
        >
          Back
        </Button>
        <Button 
          onClick={onConfirmCancel}
          variant="contained"
          color="error"
          disabled={cancelling}
          startIcon={cancelling ? <CircularProgress size={16} color="inherit" /> : <CancelIcon />}
          sx={{ minWidth: '120px' }}
        >
          {cancelling ? 'Cancelling...' : 'Cancel Action Log'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkOrderCancelConfirmationDialog;